import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from './locales/en-US.json';
import esMX from './locales/es-MX.json';

const getStoredLang = () => {
  try {
    return localStorage.getItem('lang');
  } catch {
    return null;
  }
};

const initialLang = getStoredLang() || 'en-US';

i18n.use(initReactI18next).init({
  resources: {
    'en-US': { translation: enUS },
    'es-MX': { translation: esMX },
  },
  lng: initialLang,
  fallbackLng: 'en-US',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('lang', lng);
  } catch {
    // ignore
  }
  if (document?.documentElement) {
    document.documentElement.lang = lng;
  }
});

if (document?.documentElement) {
  document.documentElement.lang = initialLang;
}

export default i18n;
